<template>
  <div class="section columns is-multiline">
    <div
      v-for="(product, index) in productList"
      :key="index"
      class="column is-6-tablet is-3-desktop"
    >
      <ProductTile
        :asin="product.ASIN"
        :item-attributes="product.ItemAttributes"
        :item-offers="product.Offers"
        :title="product.ItemAttributes.Title"
        :description="product.EditorialReviews"
        :short-link="product.DetailPageURL"
        :img-link="product.MediumImage"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getAllProductsById } from '@/api'
import ProductTile from '@/components/ProductTile'

export default {
  name: 'ProductList',
  components: {
    ProductTile
  },
  props: {
    productCategory: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      productList: []
    }
  },
  computed: {
    ...mapState(['products']),
    getProductIdsByCategory() {
      return this.products
        .filter(({ category }) => category === this.productCategory)
        .map(({ asin }) => asin)
        .join(',')
    }
  },
  async created() {
    await this.getProducts()
  },
  methods: {
    async getProducts() {
      this.productList = await getAllProductsById(
        this.getProductIdsByCategory
      ).then(res => res.data.products)
    }
  }
}
</script>
